import React from 'react';

import { ElementFill, Svg } from '~/assets/icons/styles';

const FilledClockIcon = ({ color = 'currentColor', ...props }) => {
  return (
    <Svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <ElementFill
        secondaryColor={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 8C2 4.68661 4.68661 2 8 2C11.3134 2 14 4.68661 14 8C14 11.3134 11.3134 14 8 14C4.68661 14 2 11.3134 2 8ZM8.46034 4.97143C8.46034 4.71896 8.25567 4.51429 8.0032 4.51429C7.75072 4.51429 7.54605 4.71896 7.54605 4.97143V8.49023C7.54605 8.63014 7.61012 8.76234 7.71993 8.84903L9.77707 10.4731C9.97523 10.6295 10.2627 10.5957 10.4191 10.3976C10.5756 10.1994 10.5418 9.91193 10.3436 9.75549L8.46034 8.2687V4.97143Z"
      />
    </Svg>
  );
};

export default FilledClockIcon;
